import { selectRoutes } from 'Browser/RoutesSelector';
import { Router } from '@solidjs/router';
import { IndexHtml } from 'Shared/IndexHtml';
import { SiteProvider } from 'Shared/SiteProvider';
import { SiteBasics } from 'Common/SiteBasics';
import { Environment } from 'Common/Environment';
import { User } from 'Browser/User';
import { createSignal, Suspense} from 'solid-js';
import { MetaProvider } from '@solidjs/meta';
import type {initTrpcClient} from 'Browser/Browser';


//TODO test URL queries are preserved for ?fb= shares	Q: can I add an auto test for this?

export type ConnectionToServer = ReturnType<typeof initTrpcClient>;

export interface IRootProps {
	build: Environment,
	site: SiteBasics,
	user: User,
	server: ConnectionToServer,  /* browser only (could put into server too) */
};

interface IIndexHtmlCreatorProps extends IRootProps {
	url: string
};

export function createBrowserRouter(P)
{
	return () => <IndexHtmlCreator {...P} />
}

export function createViteBrowserRouter(P)
{
	const routes = selectRoutes(P.build,P.site);

	return () => (
		<Router root={Root(P)} url={P.url}>
			{routes}
		</Router>
	);
}

export function IndexHtmlCreator(P:IIndexHtmlCreatorProps)
{
	const routes = selectRoutes(P.build,P.site);

	return (
		<IndexHtml build={P.build} site={P.site} user={P.user}>
			<Router root={Root(P)} url={P.url}>{routes}</Router>
		</IndexHtml>
	);
}

function Root(P:IRootProps) 
{
	const [user,setUser] = createSignal(P.user);

//XXX if using ErrorBoundary probably should send errors to server
//XXX perhaps also send browser-side 'page not founds' to server

	/* NOTE: the <ErrorBoundary> does prevent some server crashes. Probably removes the pretty browser errors though. */

//			<ErrorBoundary fallback={(error) => <div>Failure loading.<br/>Error: {error.message}<br/>Stack:<br/><pre>{error.stack}</pre></div>}>

	return (
		(innerProps:{children:JSXElement}) => (
			<Suspense>
				<MetaProvider>
					<SiteProvider {...P} user={user()} setUser={setUser}>
						{innerProps.children}
					</SiteProvider>
				</MetaProvider>
			</Suspense>
		)
	); 
//			</ErrorBoundary>
}	

/*
	XXX I think terms like 'import('Shared/frontend/homePage/HomePage')' are required to help Rollup create chunks.
		POSSIBLE ALTERNATIVE: https://www.npmjs.com/package/@rollup/plugin-dynamic-import-vars
		OR maybe using manualChunks option, or look at other output options

	I don't know much about this. Sometimes page chunks appear, sometimes not. Maybe Rollup
	is just combining small files.
*/


